"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var browser_1 = require("@sentry/browser");
var LEVEL_ROOT = 1;
var LEVEL_BRAND = 2;
var LEVEL_MODEL = 3;
var LEVELS = [LEVEL_ROOT, LEVEL_BRAND, LEVEL_MODEL];
var MOVE_NEXT = 1;
var MOVE_PREV = -1;
var OPTION = '.price-search-panel__option';
var ACTIVE_CLASS = 'price-search-panel__option--active';
var FILLED_CLASS = 'price-search-panel__combobox--filled';
var CascadeSelectController = /** @class */ (function (_super) {
    __extends(CascadeSelectController, _super);
    function CascadeSelectController() {
        var _a, _b;
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.DEBOUNCE_MS = 200;
        _this.BLUR_CLOSE_MS = 150;
        _this.timers = (_a = {}, _a[LEVEL_ROOT] = undefined, _a[LEVEL_BRAND] = undefined, _a[LEVEL_MODEL] = undefined, _a);
        _this.fetchSeq = (_b = {}, _b[LEVEL_BRAND] = 0, _b[LEVEL_MODEL] = 0, _b);
        _this.connect = function () {
            LEVELS.forEach(function (level) { return _this.updateFilledClass(level); });
            _this.updateSubmitState();
            void _this.hydrateFromInitial();
        };
        _this.disconnect = function () {
            LEVELS.forEach(function (level) { return window.clearTimeout(_this.timers[level]); });
        };
        _this.onInput = function (e) {
            var level = _this.levelOf(e.currentTarget);
            if (!level)
                return;
            _this.filterList(level);
            window.clearTimeout(_this.timers[level]);
            _this.timers[level] = window.setTimeout(function () { return _this.matchOnly(level); }, _this.DEBOUNCE_MS);
        };
        _this.onFocus = function (e) {
            var level = _this.levelOf(e.currentTarget);
            if (level)
                _this.openFullList(level);
        };
        _this.onClick = function (e) {
            var _a;
            var level = _this.levelOf(e.currentTarget);
            if (level && ((_a = _this.listFor(level)) === null || _a === void 0 ? void 0 : _a.hidden))
                _this.openFullList(level);
        };
        _this.onBlur = function (e) {
            var level = _this.levelOf(e.currentTarget);
            if (level)
                window.setTimeout(function () { return _this.hideList(level); }, _this.BLUR_CLOSE_MS);
        };
        _this.onSelect = function (e) {
            e.preventDefault();
            var li = e.currentTarget;
            var level = _this.levelOf(li);
            if (level)
                _this.selectItem(level, li);
        };
        _this.onToggle = function (e) {
            e.preventDefault();
            var level = _this.levelOf(e.currentTarget);
            if (!level)
                return;
            var input = _this.inputFor(level);
            var value = _this.valueFor(level);
            if (!input || !value || input.disabled)
                return;
            if (input.value || value.value) {
                input.value = '';
                value.value = '';
                _this.setSelectedOption(level);
                _this.clearDependentLevels(level);
                _this.updateFilledClass(level);
                _this.updateSubmitState();
            }
            // Opened here, not via focus(): an already-focused input fires no focus event.
            input.focus();
            _this.openFullList(level);
        };
        _this.onKeyDown = function (e) {
            var level = _this.levelOf(e.currentTarget);
            var list = level && _this.listFor(level);
            if (!level || !list)
                return;
            switch (e.key) {
                case 'ArrowDown':
                case 'ArrowUp':
                    e.preventDefault();
                    if (list.hidden)
                        _this.openFullList(level);
                    _this.moveActive(level, e.key === 'ArrowDown' ? MOVE_NEXT : MOVE_PREV);
                    break;
                case 'Enter': {
                    if (list.hidden)
                        return;
                    e.preventDefault();
                    var active = _this.activeOption(level);
                    if (active)
                        _this.selectItem(level, active);
                    break;
                }
                case 'Escape':
                    if (!list.hidden) {
                        e.preventDefault();
                        _this.hideList(level);
                    }
                    break;
            }
        };
        _this.hydrateFromInitial = function () { return __awaiter(_this, void 0, Promise, function () {
            var rootId, brandId, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        rootId = (_a = this.valueFor(LEVEL_ROOT)) === null || _a === void 0 ? void 0 : _a.value;
                        if (!rootId)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.hydrateLevel(LEVEL_BRAND, rootId, this.data.get('initial-brand'))];
                    case 2:
                        brandId = _b.sent();
                        if (!brandId) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.hydrateLevel(LEVEL_MODEL, brandId, this.data.get('initial-model'))];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        this.updateSubmitState();
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _b.sent();
                        (0, browser_1.captureException)(err_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.hydrateLevel = function (level, parentId, wantedId) { return __awaiter(_this, void 0, Promise, function () {
            var seq, options, match;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        seq = this.fetchSeq[level];
                        return [4 /*yield*/, this.fetchOptions(parentId)];
                    case 1:
                        options = _a.sent();
                        if (seq !== this.fetchSeq[level])
                            return [2 /*return*/, undefined];
                        this.populate(level, options);
                        match = wantedId ? options.find(function (o) { return String(o.id) === wantedId; }) : undefined;
                        if (!match)
                            return [2 /*return*/, undefined];
                        this.setLevelValue(level, match.id, match.name);
                        return [2 /*return*/, String(match.id)];
                }
            });
        }); };
        _this.selectItem = function (level, li) {
            var id = li.dataset.id;
            var name = li.dataset.name;
            var input = _this.inputFor(level);
            var value = _this.valueFor(level);
            if (!id || !name || !input || !value)
                return;
            input.value = name;
            value.value = id;
            _this.setSelectedOption(level, li);
            _this.hideList(level);
            _this.updateFilledClass(level);
            void _this.cascadeFetch(level, id);
            _this.updateSubmitState();
        };
        _this.cascadeFetch = function (fromLevel, parentId) { return __awaiter(_this, void 0, Promise, function () {
            var nextLevel, seq, options, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (fromLevel === LEVEL_MODEL)
                            return [2 /*return*/];
                        nextLevel = (fromLevel + 1);
                        this.clearLevel(nextLevel);
                        if (nextLevel === LEVEL_BRAND)
                            this.clearLevel(LEVEL_MODEL);
                        seq = this.fetchSeq[nextLevel];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchOptions(parentId)];
                    case 2:
                        options = _a.sent();
                        if (seq !== this.fetchSeq[nextLevel])
                            return [2 /*return*/];
                        this.populate(nextLevel, options);
                        this.updateSubmitState();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        (0, browser_1.captureException)(err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.openFullList = function (level) {
            _this.clearActive(level);
            _this.optionsOf(level).forEach(function (li) { li.hidden = false; });
            _this.showList(level);
            _this.highlightSelected(level);
        };
        _this.highlightSelected = function (level) {
            var _a;
            var list = _this.listFor(level);
            var input = _this.inputFor(level);
            var id = (_a = _this.valueFor(level)) === null || _a === void 0 ? void 0 : _a.value;
            if (!list || !input || !id || list.hidden)
                return;
            var selected = _this.optionById(level, id);
            if (!selected)
                return;
            selected.classList.add(ACTIVE_CLASS);
            input.setAttribute('aria-activedescendant', selected.id);
            list.scrollTop = selected.offsetTop;
        };
        _this.filterList = function (level) {
            var input = _this.inputFor(level);
            var list = _this.listFor(level);
            if (!input || !list)
                return;
            _this.clearActive(level);
            var needle = input.value.trim().toLowerCase();
            var visible = 0;
            for (var _i = 0, _a = _this.optionsOf(level); _i < _a.length; _i++) {
                var li = _a[_i];
                var match = !needle || (li.dataset.name || '').toLowerCase().includes(needle);
                li.hidden = !match;
                if (match)
                    visible++;
            }
            list.hidden = visible === 0 && !!needle;
        };
        _this.matchOnly = function (level) {
            var input = _this.inputFor(level);
            var value = _this.valueFor(level);
            if (!input || !value)
                return;
            var typed = input.value.trim().toLowerCase();
            var exact = _this.optionsOf(level).find(function (li) { return (li.dataset.name || '').toLowerCase() === typed; });
            var oldId = value.value;
            var newId = (exact === null || exact === void 0 ? void 0 : exact.dataset.id) || '';
            value.value = newId;
            _this.setSelectedOption(level, exact);
            _this.updateFilledClass(level);
            if (oldId !== newId) {
                _this.clearDependentLevels(level);
                if (newId && level !== LEVEL_MODEL)
                    void _this.cascadeFetch(level, newId);
            }
            _this.updateSubmitState();
        };
        _this.clearDependentLevels = function (level) {
            if (level === LEVEL_ROOT)
                _this.clearLevel(LEVEL_BRAND);
            if (level !== LEVEL_MODEL)
                _this.clearLevel(LEVEL_MODEL);
        };
        _this.clearLevel = function (level) {
            var input = _this.inputFor(level);
            var value = _this.valueFor(level);
            var list = _this.listFor(level);
            if (!input || !value || !list)
                return;
            if (level !== LEVEL_ROOT)
                _this.fetchSeq[level]++;
            input.value = '';
            value.value = '';
            input.disabled = true;
            list.innerHTML = '';
            _this.hideList(level);
            _this.updateFilledClass(level);
        };
        _this.populate = function (level, options) {
            var list = _this.listFor(level);
            var input = _this.inputFor(level);
            if (!list || !input)
                return;
            list.innerHTML = '';
            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                var opt = options_1[_i];
                var li = document.createElement('li');
                li.className = OPTION.slice(1);
                li.id = "".concat(list.id, "-option-").concat(opt.id);
                li.textContent = opt.name;
                Object.assign(li.dataset, {
                    level: String(level),
                    id: String(opt.id),
                    name: opt.name,
                    hasData: String(opt.has_data),
                    action: 'mousedown->price-search--cascade-select#onSelect'
                });
                li.setAttribute('role', 'option');
                li.setAttribute('aria-selected', 'false');
                list.appendChild(li);
            }
            input.disabled = options.length === 0;
        };
        _this.setLevelValue = function (level, id, name) {
            var input = _this.inputFor(level);
            var value = _this.valueFor(level);
            if (!input || !value)
                return;
            input.value = name;
            value.value = String(id);
            _this.setSelectedOption(level, _this.optionById(level, id));
            _this.updateFilledClass(level);
        };
        _this.updateFilledClass = function (level) {
            var wrapper = _this.wrapperFor(level);
            var value = _this.valueFor(level);
            if (wrapper && value)
                wrapper.classList.toggle(FILLED_CLASS, value.value.length > 0);
        };
        _this.showList = function (level) {
            var list = _this.listFor(level);
            if (!list || _this.optionsOf(level).length === 0)
                return;
            list.hidden = false;
            _this.setExpanded(level, true);
        };
        _this.hideList = function (level) {
            var list = _this.listFor(level);
            if (list)
                list.hidden = true;
            _this.setExpanded(level, false);
            _this.clearActive(level);
        };
        _this.setExpanded = function (level, expanded) {
            var _a;
            (_a = _this.inputFor(level)) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', String(expanded));
        };
        _this.setSelectedOption = function (level, selected) {
            _this.optionsOf(level).forEach(function (li) { return li.setAttribute('aria-selected', String(li === selected)); });
        };
        _this.moveActive = function (level, delta) {
            var input = _this.inputFor(level);
            var visible = _this.optionsOf(level).filter(function (li) { return !li.hidden; });
            if (!input || visible.length === 0)
                return;
            var currentIdx = visible.findIndex(function (li) { return li.classList.contains(ACTIVE_CLASS); });
            var nextIdx = currentIdx === -1
                ? (delta > 0 ? 0 : visible.length - 1)
                : (currentIdx + delta + visible.length) % visible.length;
            visible.forEach(function (li) { return li.classList.remove(ACTIVE_CLASS); });
            var active = visible[nextIdx];
            active.classList.add(ACTIVE_CLASS);
            active.scrollIntoView({ block: 'nearest' });
            input.setAttribute('aria-activedescendant', active.id);
        };
        _this.activeOption = function (level) {
            return _this.optionsOf(level).find(function (li) { return li.classList.contains(ACTIVE_CLASS); });
        };
        _this.clearActive = function (level) {
            var _a;
            _this.optionsOf(level).forEach(function (li) { return li.classList.remove(ACTIVE_CLASS); });
            (_a = _this.inputFor(level)) === null || _a === void 0 ? void 0 : _a.removeAttribute('aria-activedescendant');
        };
        // Any charting level keeps submit open; a deeper pick without data lands on
        // the no-result page rather than locking the button.
        _this.updateSubmitState = function () {
            if (!_this.submitTarget)
                return;
            _this.submitTarget.disabled = !LEVELS.some(function (level) {
                var _a, _b;
                var id = (_a = _this.valueFor(level)) === null || _a === void 0 ? void 0 : _a.value;
                return id && ((_b = _this.optionById(level, id)) === null || _b === void 0 ? void 0 : _b.dataset.hasData) === 'true';
            });
        };
        _this.fetchOptions = function (parentId) { return __awaiter(_this, void 0, Promise, function () {
            var endpoint, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = this.data.get('endpoint');
                        if (!endpoint)
                            throw new Error('cascade-select: missing endpoint');
                        url = "".concat(endpoint, "?parent_id=").concat(encodeURIComponent(parentId));
                        return [4 /*yield*/, fetch(url, { headers: { Accept: 'application/json' } })];
                    case 1:
                        res = _a.sent();
                        if (!res.ok)
                            throw new Error("price-search cascade fetch failed: ".concat(res.status));
                        return [4 /*yield*/, res.json()];
                    case 2: return [2 /*return*/, (_a.sent()).options || []];
                }
            });
        }); };
        _this.optionsOf = function (level) {
            var _a;
            return Array.from(((_a = _this.listFor(level)) === null || _a === void 0 ? void 0 : _a.querySelectorAll(OPTION)) || []);
        };
        _this.optionById = function (level, id) {
            var _a;
            return ((_a = _this.listFor(level)) === null || _a === void 0 ? void 0 : _a.querySelector("".concat(OPTION, "[data-id=\"").concat(id, "\"]"))) || undefined;
        };
        _this.inputFor = function (level) { var _a; return (_a = _this.inputTargets) === null || _a === void 0 ? void 0 : _a[level - 1]; };
        _this.valueFor = function (level) { var _a; return (_a = _this.valueTargets) === null || _a === void 0 ? void 0 : _a[level - 1]; };
        _this.listFor = function (level) { var _a; return (_a = _this.listTargets) === null || _a === void 0 ? void 0 : _a[level - 1]; };
        _this.wrapperFor = function (level) { var _a; return (_a = _this.wrapperTargets) === null || _a === void 0 ? void 0 : _a[level - 1]; };
        _this.levelOf = function (el) {
            var _a;
            var level = Number((_a = el === null || el === void 0 ? void 0 : el.dataset) === null || _a === void 0 ? void 0 : _a.level);
            return LEVELS.includes(level) ? level : undefined;
        };
        return _this;
    }
    CascadeSelectController.targets = ['input', 'value', 'list', 'wrapper', 'submit'];
    return CascadeSelectController;
}(stimulus_1.Controller));
exports.default = CascadeSelectController;
